import io from 'socket.io-client';
import { createContext, useContext, useEffect, useMemo } from "react";
import { useParams } from 'react-router-dom';
import { decryptUrlSafe } from '../utils/helpers';

const SocketContext = createContext(null);

const useSocket = () => useContext(SocketContext);

const SocketProvider = ({ children }) => {
    const { id: employeeId } = useParams();
    const employee_id = decryptUrlSafe(employeeId);

    const socket = useMemo(() => {
        return io(process.env.REACT_APP_BASE_URL, {
            withCredentials: true,
            reconnection: true,             // reconnect automatically
            reconnectionAttempts: 5,        // max attempts
            reconnectionDelay: 2000         // delay between attempts

        })
    }, []);

    useEffect(() => {
        socket.on('connect', () => {
            console.log('🔌 Socket connected:', socket.id);
            if (employee_id) {
                socket.emit('join-employee-room', { employeeId: employee_id });
            }
        });

        socket.on('disconnect', (reason) => {
            console.log('⚠️ Socket disconnected:', reason);
        });

        socket.on("connect_error", (err) => {
            const code = err?.data?.code;
            if (err?.data?.shouldRedirect && ["AUTH_TOKEN_EXPIRED", "AUTH_TOKEN_MISSING"].includes(code)) {
                // clear local auth state if needed
                window.location.href = "/login";
            }
        });

        return () => {
            socket.off('connect');
            socket.off('disconnect');
        }
    }, [socket])

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
}

export { SocketProvider, useSocket };
